import { Component, ElementRef, EventEmitter, Input, Output, ViewChild } from '@angular/core';
import { AbstractControl, FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { NotifierService } from 'angular-notifier';
import { UserService } from '../user-management/service/user.service';
import { LoginService } from '../../../../components/login/service/login.service';
import { UserManagementComponent } from '../user-management/user-management.component';
import * as CryptoJS from 'crypto-js';
import Validation from '../../../../validation/confirm-password-validation';
import intlTelInput from 'intl-tel-input';
import { HttpErrorResponse } from '@angular/common/http';

@Component({
  selector: 'app-user-details',
  templateUrl: './user-details.component.html',
  styleUrl: './user-details.component.scss'
})
export class UserDetailsComponent {
  userDetailsForm!: FormGroup;
  passwordResetForm!: FormGroup;
  userDetails: any;
  name!: string;
  getUserList: any = [];
  email!: string;
  phoneno!: string;
  is_meeting_user!: string;
  showSelect: boolean = false;
  spliceUserList: any = [];
  getDeleteUserData!: Object;
  deactivate: boolean = false;
  passwordFormShow: boolean = false;
  tooltipShowValue!: boolean;
  spinner: boolean = false;
  type: string = 'password';
  isText = false;
  eyeIcon = 'fa-eye-slash';
  passwordIcon = 'fa fa-lock';
  showToolTip: boolean = false;
  getSuperAdminRole!:number;
  private readonly notifier: NotifierService;
  @Input() userDetailInput: any;
  @Input() getRole: any;
  @Input() closePwdForm: any;
  @Output() deleteUserEmit = new EventEmitter();
  @Input() spinnerReceive: boolean = true;
  //@ViewChild('intlInput') intlInput!: ElementRef;
  myOptions = {};
  storeUrlId!: number;
  submitted = false;
  userId!: string;
  userId2!: any;
  userId_temp!: any;
  adminClass!: string;
  passwordForm: FormGroup = new FormGroup({
    password: new FormControl(''),
    confirmPassword: new FormControl(''),
  });
  initContry:any;
  constructor(
    private fb: FormBuilder,
    private router: Router,
    private userListService: UserService,
    private notifierService: NotifierService,
    private userMangementComp: UserManagementComponent,
    private service:LoginService
    
  ) {
    this.notifier = notifierService;
  }

  ngOnChanges() {
    this.spinner = this.spinnerReceive;
    this.userDetailsForm?.patchValue(this.userDetailInput);
    if (
      this.userMangementComp.resetPasswordForm ||
      !this.userMangementComp.resetPasswordForm
    ) {
      this.passwordForm.reset();
    }
    if (this.closePwdForm) {
      this.hidePasswordForm();
    }
    this.userId = this.userDetailInput.userid.$oid;
    let user:any = localStorage.getItem("user");
      
          var data = CryptoJS.AES.decrypt(user,this.service.enCryptKey).toString(CryptoJS.enc.Utf8);
            const userRole = JSON.parse(data);
    this.userId_temp = userRole;
    this.userId2 = this.userId_temp?.userid;
    if (this.userId === this.userId2 || this.userDetailInput?.role === 102) {
      this.adminClass = 'form-control';
      this.userDetailsForm?.get('role')?.disable();
    } else {
      this.adminClass = 'form-select';
      this.userDetailsForm?.get('role')?.enable();
    }
    this.myOptions = {
      placement: 'top',
      hideDelay: 0,
      showDelay: 200,
      maxWidth: 200,
      trigger: 'hover',
      shadow: true,
      display: !this.getRole && this.adminClass === 'form-select',
    };
    if(this.getSuperAdminRole === 100 && this.getRole){
      this.userDetailsForm?.get('name')?.disable();
    }else{
      this.userDetailsForm?.get('name')?.enable();
    }
  }


  ngOnInit(): void {
    this.submitted = false;
    this.userId = this.userDetailInput.userid.$oid;
    let user:any = localStorage.getItem("user");
    var data = CryptoJS.AES.decrypt(user,this.service.enCryptKey).toString(CryptoJS.enc.Utf8);
    const userRole = JSON.parse(data);
    this.userId_temp = userRole;
    this.userId2 = this.userId_temp?.userid;
    this.getSuperAdminRole = this.userId_temp?.role;
    this.myOptions = {
      placement: 'top',
      hideDelay: 0,
      showDelay: 200,
      maxWidth: 200,
      trigger: 'hover',
      shadow: true,
      display: !this.getRole && this.adminClass === 'form-select',
    };
    this.userDetailsForm = this.fb.group({
      name: ['', [Validators.required,Validators.pattern(/^[A-Za-z]+(?:\s[A-Za-z]+)*$/)]],
      role: [''],
      email: ['',[Validators.required, Validators.email,Validators.pattern('^[a-z0-9._%+-]+@[a-z0-9.-]+\\.[a-z]{2,4}$')]],
      phoneno: ['',[Validators.required, Validators.pattern('^[+][0-9]{12}$')]],
    });
    this.userDetailsForm?.patchValue(this.userDetailInput);
    this.passwordForm = this.fb.group(
      {
        password: [
          '',
          [
            Validators.required,
            Validators.minLength(8),
            Validators.maxLength(40),
            Validators.pattern(
              '(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[$@$!%*?&])[A-Za-zd$@$!%*?&].{8,}'
            ),
          ],
        ],
        confirmPassword: ['', Validators.required],
      },
      {
        validators: [Validation.match('password', 'confirmPassword')],
      }
    );
    if (this.userId === this.userId2 || this.userDetailInput?.role === 102) {
      this.adminClass = 'form-control';
      this.userDetailsForm?.get('role')?.disable();
    } else {
      this.adminClass = 'form-select';
      this.userDetailsForm?.get('role')?.enable();
    }
    if(this.getSuperAdminRole === 100 && this.getRole){
      this.userDetailsForm?.get('name')?.disable();
    }else{
      this.userDetailsForm?.get('name')?.enable();
    }

    this.userDetailsForm?.get('email')?.disable();
    this.userDetailsForm?.get('phoneno')?.disable();
  }


  get f(): { [key: string]: AbstractControl } {
    return this.passwordForm.controls;
  }

  get userdetailform(): { [key: string]: AbstractControl } {
    return this.userDetailsForm.controls;
  }


  hideShowPassword() {
    this.isText = !this.isText;
    this.isText ? (this.eyeIcon = 'fa-eye') : (this.eyeIcon = 'fa-eye-slash');
    this.isText ? (this.type = 'text') : (this.type = 'password');
  }

  goBack() {
    this.userDetailsForm.reset();
    this.userDetailsForm?.patchValue(this.userDetailInput);
  }

  updateUserDetails() {
    if(this.userDetailsForm.valid){
      this.submitted = true;
    this.spinner = true;
    const formObject = {
     // email: this.userDetailInput?.email,
      is_meeting_user: this.userDetailInput?.is_meeting_user.toString(),
      //phonenumber: this.userDetailsForm.value['phonenumber'],
      role: this.userDetailsForm.value['role']
        ? this.userDetailsForm.value['role']
        : this.userDetailInput?.role,
      topic_id: this.userDetailInput?.topic_id,
      userid: this.userDetailInput?.userid.$oid,
      username: this.userDetailsForm.value['name']
        ? this.userDetailsForm.value['name']
        : this.userDetailInput?.name,
    };
    this.userListService.updateUser(formObject).subscribe(
      (sub) => {
        this.userDetailInput.name = formObject.username;
        this.userDetailInput.role = formObject.role;
        this.notifier.notify('default', 'Updated SuccessFully.');
        this.spinner = false;
        this.goBack();
        this.submitted = false;
      },
      (error) => {
        console.log('user update error', error);
        this.spinner = false;
      }
    );
  }else{
    this.submitted = false
  }
  }

  deleteUserFun(data: any) {
    this.getDeleteUserData = data;
  }

  deleteUserEmitFun(data: any) {
    const storeId = data.userid.$oid;
    
    this.userListService.deleteUser(storeId).subscribe({
      next:(sub:any) => {
        this.deleteUserEmit.emit(data);
        this.userDetailsForm.reset();
        this.userDetailInput.name = 'No User';
        this.notifier.notify('default', 'User is deleted sucessfully.');
      },
      error:(error:HttpErrorResponse) => {
        console.log('user delete error', error);
        this.notifier.notify('default', error.error['message']);
      }
    });
  }

  deactivateUserFun(data: any) {
    this.deactivate = true;
    const formObject = {
      userid: data.userid.$oid,
      activate: data.active === 'Y' ? 'N' : 'Y',
    };
    this.userListService.deactivateUser(formObject).subscribe(
      (sub) => {
        this.userDetailInput.active = formObject.activate;
        if (formObject.activate == 'Y') {
          this.notifier.notify('default', 'User is activated.');
        } else {
          this.notifier.notify('default', 'User is deactivated.');
        }
      },
      (error) => {
        console.log('deactive user error', error);
      }
    );
  }

  deactivateUserEmitFun(data: any) {
    this.deactivate = true;
    const formObject = {
      userid: data.userid.$oid,
      activate: data.active === 'Y' ? 'N' : 'Y',
    };
    this.userListService.deactivateUser(formObject).subscribe(
      (sub) => {
        this.userDetailInput.active = formObject.activate;
        if (formObject.activate == 'Y') {
          this.notifier.notify('default', 'User is activated.');
        } else {
          this.notifier.notify('default', 'User is deactivated.');
        }
      },
      (error) => {
        console.log('deactive user error', error);
      }
    );
  }

  openPasswordForm() {
    this.passwordFormShow = true;
  }

  hidePasswordForm() {
    this.passwordForm.reset();
    this.submitted = false;
    this.passwordFormShow = false;
  }
  makeRandom(lengthOfCode: number, possible: string) {
    let text = '';
    for (let i = 0; i < lengthOfCode; i++) {
      text += possible.charAt(Math.floor(Math.random() * possible.length));
    }
    return text;
  }

  onSubmit(): void {
    this.submitted = true;
    if (this.passwordForm.invalid) {
      return;
    }
    const values = this.passwordForm.value;
    const password = values.password;
    const possible =
      "ABCDEFGHIJKLMNOPQRSTUVWXYZ1234567890,./;'[]=-)(*&^%$#@!~`";
    const dynamic_str = this.makeRandom(16, possible);
    const salt = this.makeRandom(16, possible);
    const iterations = 128;
    const bytes = CryptoJS.PBKDF2(dynamic_str, salt, {
      keySize: 48,
      iterations: iterations,
    });
    const iv = CryptoJS.enc.Hex.parse(bytes.toString().slice(0, 32));
    const key = CryptoJS.enc.Hex.parse(bytes.toString().slice(32, 96));

    const ciphertext = CryptoJS.AES.encrypt(password, key, { iv: iv });
    const formEncript = {
      userid: this.userDetailInput?.userid?.$oid,
      encrypted_data: ciphertext.toString(),
      salt: salt,
      pass_phrase: dynamic_str,
    };
    this.spinner = true;
    this.userListService.changePassword(formEncript).subscribe({
      next: (response) => {
        this.spinner = false;
        this.notifier.notify('default', 'Password changed successFully.');
        this.passwordForm.reset();
        this.submitted = false;
        this.passwordFormShow = false;
      },
      error: (err) => {
        console.log(err);
        this.notifier.notify(
          'error',
          'Incorrect Password or Something Error !'
        );
        this.spinner = false;
      },
    });
  }

  //  ngAfterViewInit() {
  //     this.initContry = intlTelInput(this.intlInput.nativeElement, {
  //       allowDropdown: true,
  //       nationalMode: true,
  //       initialCountry: 'in',
  //       separateDialCode: false
  //     });
  //  }


}
